module.exports = __webpack_public_path__ + "static/puppies-blanket-1-0ed6af38b5bc2fa6458af9fe06c2862e.jpg";